import { getYear } from 'date-fns'
import css from './yearPicker.module.css'
import cn from '../../../../../utils/cn.ts'

interface YearPickerProps {
  startDate: Date
  endDate?: Date
  currentMonth?: Date
  range?: boolean
  double?: boolean
  onSelect: (date: Date | [Date, Date]) => void
  handlePrevDecade: () => void
  handleNextDecade: () => void
}

const YearPicker: React.FC<YearPickerProps> = ({
  range,
  double,
  endDate,
  currentMonth,
  startDate,
  handlePrevDecade,
  handleNextDecade,
  onSelect,
}) => {
  const currentYear = getYear(currentMonth || new Date())
  const startYear = Math.floor(currentYear / 10) * 10
  const secondStartYear = startYear + 10

  const isStartYear = (year: number) => range && startDate && getYear(startDate) === year
  const isEndYear = (year: number) => range && endDate && getYear(endDate) === year
  const isRangeYear = (year: number) => {
    return range && startDate && endDate && year > getYear(startDate) && year < getYear(endDate)
  }
  const isSelected = (year: number) => {
    return !range && getYear(startDate) === year
  }

  const handleYearClick = (year: number, isDisabled = false) => {
    if (isDisabled) {
      if (year < startYear) handlePrevDecade()
      if (year >= startYear + 10) handleNextDecade()
    }
    onSelect(new Date(year, 0))
  }

  const renderYearPicker = (startYear: number) => {
    return (
      <div className={css.yearPicker}>
        {[...Array(12)].map((_, index) => {
          const year = startYear - 1 + index
          const isDisabled = index === 0 || index === 11

          return (
            <div
              key={year}
              className={cn({
                [css.yearOption]: true,
                [css.selected]: isSelected(year),
                [css.rangeStart]: isStartYear(year),
                [css.rangeEnd]: isEndYear(year),
                [css.inRange]: isRangeYear(year),
                [css.disabled]: isDisabled,
              })}
              onClick={() => handleYearClick(year, isDisabled)}
            >
              {year}
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div className={css.wrapperContainer}>
      {renderYearPicker(startYear)}
      {double && renderYearPicker(secondStartYear)}
    </div>
  )
}

export default YearPicker
